import React, { useEffect, useState } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEditBillingShiftDifferentialRows,
  selectEditPayrollShiftDifferentialRows,
  selectShiftDifferentialAmountError,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { findIndex, findRow } from '../Utils';
import { modsEnums } from 'app/models/Placement/PlacementMods';
import { missingField } from 'app/constants';

interface GridCellProps {
  [key: string]: any;
}

export const EditAmountCell = (props: any) => {
  return <EditAmount cellParams={props?.cellParams} currentMod={props?.currentMod} />;
};

const EditAmount = React.memo(function EditAmount(params: GridCellProps) {
  const dispatch = useDispatch();
  const { control } = useFormContext();
  const { t } = useTranslation();
  const amount = params?.cellParams?.row?.amount;
  const [currentAmount, setCurrentAmount] = useState(amount === missingField ? '' : amount);
  //@Team @Lakshmi Can not write the useSelectors that are used conditionally
  const shiftDiffEditRequests =
    params?.currentMod === modsEnums.PayrollShiftDifferential
      ? useSelector(selectEditPayrollShiftDifferentialRows)
      : useSelector(selectEditBillingShiftDifferentialRows);
  const rowId = params?.cellParams?.id;
  const amountErrors = useSelector(selectShiftDifferentialAmountError);
  const checkAndSetEntryValue = value => {
    const pattern = /^(?:(\d{1,4})(?:\.(\d{0,2}))?|(\d{5})(?:\.(\d{0,1}))?|(\d{6}))$/;

    if (pattern.test(value)) {
      setCurrentAmount(value);
      return value;
    } else {
      setCurrentAmount(value.slice(0, -1));
      return null;
    }
  };

  const setAmountEdit = data => {
    let newRow = shiftDiffEditRequests.slice(0);

    const shiftDiffEditRow = findRow(params, shiftDiffEditRequests, rowId);
    const dataToUpdate = checkAndSetEntryValue(data) === null ? null : Number(checkAndSetEntryValue(data));
    const updatedCell = { ...shiftDiffEditRow, amount: dataToUpdate };
    const editIndex = findIndex(updatedCell, params, shiftDiffEditRequests, rowId);

    newRow[editIndex] = updatedCell;
    switch (params?.currentMod) {
      case modsEnums.PayrollShiftDifferential: {
        dispatch(placementModsAction.setEditPayrollShiftDiffRows(newRow));
        break;
      }
      case modsEnums.BillingShiftDifferential: {
        dispatch(placementModsAction.setEditBillingShiftDiffRows(newRow));
        break;
      }
    }
  };

  useEffect(() => {
    if (params?.cellParams?.error !== null && params?.cellParams?.error !== undefined) {
      const val = amountErrors?.filter(el => el.id === params?.cellParams?.id);

      const arr = amountErrors?.length > 0 ? amountErrors?.slice(0) : [];
      if (val?.length === 0) {
        const valueObj = { amount: params?.cellParams?.error, id: params?.cellParams?.id };
        arr.push(valueObj);
      } else {
        const currentObj = arr.find(val => val.id === params?.cellParams?.id);
        const updatedObj = { ...currentObj, amount: params?.cellParams?.error };
        const editIndex = arr.findIndex(val => val.id === params?.cellParams?.id);

        arr[editIndex] = updatedObj;
      }
      dispatch(placementModsAction.setShiftDifferentialAmountError(arr));
    }
  }, [params?.cellParams?.error]);

  return (
    <>
      <Controller
        name={`shiftDiffRequests${rowId}.amount`}
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <TextField
            required={true}
            variant="outlined"
            size={'small'}
            style={{ width: '150px' }}
            value={currentAmount}
            onBlur={e => {
              setAmountEdit(e.target.value);
            }}
            InputProps={{
              startAdornment: <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>,
              sx: { fontSize: '14px' },
            }}
            onChange={e => {
              if (e.target.value) {
                checkAndSetEntryValue(e.target.value);
              } else {
                setCurrentAmount(null);
              }
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
